import useCache from "./useCache";
import useCacheKey from "./useCacheKey";

type TutorialCacheData = {
	hasSeenExamDateTutorial: boolean;
	hasSeenAiDisclaimer?: boolean;
};

const defaultTutorialData: TutorialCacheData = {
	hasSeenExamDateTutorial: false,
	hasSeenAiDisclaimer: false,
};
const useTutorialCache = () => {
	const { tutorialCacheKey } = useCacheKey();
	const { data: tutorialData, setCache } = useCache<TutorialCacheData>({
		key: tutorialCacheKey || "",
		defaultData: defaultTutorialData,
		enabled: true,
		staleTime: Number.POSITIVE_INFINITY,
		shouldInvalidate: true,
		shouldOptimisticUpdate: true,
	});

	const setTutorialData = (data: Partial<TutorialCacheData>) => {
		setCache({
			...tutorialData,
			...data,
		});
	};

	return {
		tutorialData,
		setTutorialData,
	};
};

export default useTutorialCache;
